
import Phrase from '../Phrase/Phrase';

import { useEffect } from 'react';
import { WarningIcon } from '../../primitives/media/Icons';
import {
  RippleInfoDetail,
  RippleWarningModalHeader,
} from '../../primitives/styles/Ripples/RipplesStyle';

import {
  ErrorWarningMsg,
  ErrorModalWrapper,
  ErrorModalContent,
  ErrorModalColumnTitle,
  DesignLimitErrorDetailsWrapper,
} from '../../primitives/styles/Common/CommonStyle'

const OnboardingStateError: React.FC = () => {
  useEffect(() => {
    document.body.style.position = 'fixed';
    document.body.style.top = `-${window.scrollY}px`;
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
    };
  });

  return (
    <ErrorModalWrapper>
      <ErrorModalContent>
        <RippleWarningModalHeader>
          <ErrorModalColumnTitle>
            <WarningIcon />
            <Phrase
              translationKey="e9a1884f-7b70-450b-8029-bcace70ed2a6"
              defaultText="Login Fail"
            />
          </ErrorModalColumnTitle>
        </RippleWarningModalHeader>
        <DesignLimitErrorDetailsWrapper>
          <RippleInfoDetail>
            <ErrorWarningMsg>
                <Phrase
                  translationKey="403bf26e-cc85-45d5-a631-4c94b3abbfec"
                  defaultText="Something went wrong. Please scan the QR code again."
                />
            </ErrorWarningMsg>
          </RippleInfoDetail>
        </DesignLimitErrorDetailsWrapper>
      </ErrorModalContent>
    </ErrorModalWrapper>
  );
};

export default OnboardingStateError;
